/**
 * @license
 * Copyright 2022 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}popup`;
const attributes = {
    CONTAINER: 'forge-popup',
    OPEN: 'open',
    PLACEMENT: 'placement',
    MANAGE_FOCUS: 'manage-focus',
    ANIMATION_TYPE: 'animation-type',
    STATIC: 'static',
    HIDE_WHEN_CLIPPED: 'hide-when-clipped',
    HOST: 'forge-popup-host',
    INITIAL_FOCUS: 'forge-popup-focus'
};
const classes = {
    OPEN: 'forge-popup--open',
    OPENING: 'forge-popup--opening',
    CLOSED: 'forge-popup--closed',
    SELECT: 'forge-popup--select'
};
const selectors = {
    HOST: `.forge-popup-host, [${attributes.HOST}]`,
    CONTAINER: '.forge-popup',
    INITIAL_FOCUS: `[${attributes.INITIAL_FOCUS}]`
};
const events = {
    OPEN: `${elementName}-open`,
    CLOSE: `${elementName}-close`,
    POSITION: `${elementName}-position`,
    BLUR: `${elementName}-blur`
};
const numbers = {
    ANIMATION_DURATION: 120
};
export const POPUP_CONSTANTS = {
    elementName,
    classes,
    selectors,
    attributes,
    events,
    numbers
};
export var PopupAnimationType;
(function (PopupAnimationType) {
    PopupAnimationType["None"] = "none";
    PopupAnimationType["Menu"] = "menu";
    PopupAnimationType["Dropdown"] = "dropdown";
})(PopupAnimationType || (PopupAnimationType = {}));
